import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable } from 'rxjs';

import { BisnodeData } from '@orgbrain/lib-admin';

import { BrregHelperService } from './brreg-helper.service';

@Injectable({
  providedIn: 'root',
})
export class BisnodeService {
  http = inject(HttpClient);
  private brregService = inject(BrregHelperService);


  getSuggestions(org_id): Observable<BisnodeData> {
    return from(this.brregService.getOrgByOrgId(org_id)) as any;
  }
}
